import React, { Component } from 'react'
import './css/Card.css'
import { Link } from 'react-router-dom'

export default class Card extends Component {
  constructor(props){
    super(props) 
    this.state = {
      req_link: this.props.req_link,
      link: this.req_link,
    }
  }

  req_link = () => {
    if (this.props.req_link === "Case studies"){
      return `/Fproject/${this.props.name}`
    }
    else if(this.props.req_link === "Ux design"){
      return `/Uxproject/${this.props.name}`
    }
    else if(this.props.req_link === "Ui design"){
      return `/Uiproject/${this.props.name}`
    }

    else if(this.props.req_link === "Graphic design"){
      return `/Dailyproject/${this.props.name}`
    }
  }

  dev = () => {
    if(this.props.req_link === "Development"){
      if(this.props.name === "Learner"){
        window.open(
          'https://uxunicorn-learner.netlify.app/',
          '_blank' 
        )
      }else if(this.props.name === "Amazon-clone"){
        window.open(
          'https://challenge-5faf6.web.app/',
          '_blank' 
        )
    } else if(this.props.name === "Ecom"){
        window.open(
          'https://rohith-001.github.io/Ecom-bootstrap/',
          '_blank' 
        )
    }
    }
  }

    render() {
        return (
          <Link  to={this.state.link} onClick={this.dev} className="card"  style={{overflow: 'hidden'}}>
            <img className="card-img-top" src={require(`../Images/Cards/${this.props.name}.png`)} alt="Case_studies_1" />
            <div className="card-img-overlay" id="over">
              <p className="card-text text-muted">2019 - 2020</p>
              <h3 className="card-title text-white">{this.props.name}</h3>
              <p className="text-white font-weight-normal h5" id="link" style={{position: 'absolute', opacity: 0, paddingTop: '40px'}}>view here</p>
            </div>
          </Link>
        )
    }
}
